var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 146.4 169" },
      attrs: {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 146.4 169",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "linearGradient",
        {
          attrs: {
            id: "SVGID_1_",
            gradientUnits: "userSpaceOnUse",
            x1: "1.6702",
            y1: "84.4905",
            x2: "144.7229",
            y2: "84.4905",
          },
        },
        [
          _c("stop", {
            staticStyle: { "stop-color": "#4CAE4E" },
            attrs: { offset: "3.136546e-03", id: "stop_1" },
          }),
          _vm._v(" "),
          _c("stop", {
            staticStyle: { "stop-color": "#488ECB" },
            attrs: { offset: "1", id: "stop_2" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("path", {
        staticClass: "st16",
        attrs: {
          d: "M144,46.4c-0.7-0.7-1.9-1.2-1.9-1.2s-0.4-1.6-1-2.6c-0.6-1-1.7-2.2-1.7-2.2s0.2-3.8-1.1-8.2\n\tc1.5-6.3-1-13.6-5.8-15.9c-2.3-1.1-4.7-1.4-7-1c0.2,0.1,0.4,0.2,0.6,0.3l-0.1,0c2,0.9,3.7,2.3,5,4c1.3,1.7,2.2,3.6,2.8,5.6\n\tc0.6,2,0.9,4.1,0.7,6.2c0,0.4-0.1,0.8-0.1,1.2c0,0.2-0.1,0.4-0.1,0.7l0,0c-0.2,1.4-0.7,2.8-1.3,4.1c0.6-1.9,0.5-3.8,0.4-5.8\n\tc-0.1-2-0.5-3.7-1.3-5.6c-0.8-1.8-1.7-3.6-3.1-5.1c-2.1-2.3-6-4.6-9.4-5.3c-1.9-0.4-4-0.5-5.9-0.2c-2,0.3-3.9,1-5.6,2\n\tc-1.8,1-3.2,1.7-4.7,3.2c1.2-1.7,2.7-3.2,4.4-4.5c1.7-1.2,3.7-2.1,5.8-2.6c2-0.4,4-0.4,6-0.1c-1.6-0.6-3.1-1.3-4.4-2.1\n\tc-8-5-18.6-10-23.2-9.7c-7.6,0.4-9,9-7.5,13.2c0.7,2.1,1.5,4.6,1.8,6.8c0.1,0.3,0.1,0.6,0.2,0.9c0.2,1,0.2,2,0.2,3\n\tc0,0.1,0,0.3,0,0.4c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3-0.1,0.5c0,0.1,0,0.3-0.1,0.4c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.3-0.1,0.4\n\tc0,0.1-0.1,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.1-0.1,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4\n\tc0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3\n\tc0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1\n\tc0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1-0.4,0.1-0.9,0.2-1.3c0-0.1,0-0.2,0-0.2c0.1-0.5,0.1-0.9,0.1-1.4\n\tc0-0.1,0-0.2,0-0.3c0-0.5,0.1-1,0.1-1.5c0,0,0-0.1,0-0.1c0-0.5,0-1,0-1.5c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.4,0-0.8,0-1.2\n\tc-5.9-0.2-11.5,0.5-16.7,1.5c-32,6.3-49.3,23.7-56.4,35.6c-10,16.9-12,32.8-8.8,49.1c5.7,37.3,29.1,50,41.8,53.7\n\tc19.7,5.4,31.8-1.3,36.2-3.8c17.8-10.5,23.5-29.4,15.6-43.2c-7.9-14-24.4-17.6-37.1-8c-9.3,7-10.5,19.9-2.5,28\n\tc2.5,2.6,5.6,4.6,9.5,4.6c2.4,0,4.4-1.6,5-3.8c0.6-2-0.4-4.4-2.5-5.6c-0.3-0.2-0.5-0.3-0.8-0.4c-0.1,0-0.2-0.1-0.3-0.2\n\tc-1.5-1-5.2-4.4-2.1-10.4c2.9-5.6,16.4-7.4,18.5,5.9c1.5,9.2-6.6,18.2-16.7,20.9c-13.1,3.4-25.2-1.2-33-9\n\tc-8.5-8.5-14.1-18.7-11.4-33.9C26,92.1,37.5,85.3,45.2,82.8c1.5-0.5,2.9,1,2.3,2.5c-0.3,0.8-0.8,1.7-1.2,2.6\n\tc-0.4,1.4-0.7,2.7-0.4,4.3c0.6,4.3,3.6,6.7,6.6,6.4c0.5,0,0.9-0.3,1.2-0.6l0.4-0.5c0.5-0.5,0.6-1.3,0.3-1.9\n\tc-0.8-1.6-1.7-2.9-1.7-4.7c0-0.9,0.1-2.3,1.4-2.1l0,0c1.8,0.7,3.4-1.5,2.1-2.9c-0.3-0.4-0.7-0.7-1.1-1c-2.6-2.1-2.5-4.6,1-5.3\n\tc0.6-0.1,1.1-0.4,1.7-0.5c0.9-0.3,1.9,0.2,2.3,1.1c0.4,0.9,0.8,1.9,1.2,3c0,0,1.1,2.5,0,3.3c-1.1,0.8-3.2,0.9-2.5,2.8\n\tc0.2,0.5,1.6,0.8,3.1,0.3c1.5-0.5,6.8-1.2,8.7,0.7c0.9,0.9,1.3,0.5,1.4-0.2c0.3-1.1-0.4-2.3-1.4-2.7c-1.3-0.5-3-1.2-3.7-1.3\n\tc-1-0.2,1.1-2.5-0.2-7.3c-0.3-1.1,0.4-2.1,1.5-2.3c0.3,0,0.6-0.1,0.9-0.1c0.9-0.1,1.7,0.4,2,1.2c1.1,3,2,5.5,2.4,6.4\n\tc0.5,0.9,0.6,2.1,0.6,3.2c-0.1,2.9,0.5,5.6,1.4,8.3c0.6,2,4.2,3.6,6.1,2.6c0.2-0.1,0.3-0.3,0.5-0.4l0.8-1c-1.9-2-1.2-4.5-0.9-6.8\n\tc0.1-0.8,1-0.6,2-0.7l0,0c1.1-0.2,1.7-1.5,1-2.4c-0.2-0.3-0.4-0.5-0.6-0.7c-0.7-0.5-4.3-3-4.8-3.9c-0.9-0.9-1.7-2-2.3-3.2\n\tc-0.6-1.2-1.2-3.5,0-4.2c2.7-1.6,7.3-2.2,11-2.3c0.4,0,0.8,0.1,1.2,0.4c0.7,0.5,1.3,1,1.6,1.3c2.6,2.3,5.1,6.8,8,10.5\n\tc0,0,1.7,2.1,0.9,3.2c-0.9,1.1-2.8,1.7-1.7,3.4c0.3,0.5,1.7,0.4,3.1-0.5c1.3-0.9,6.2-3,8.6-1.7c1.1,0.6,1.3,0.1,1.3-0.5\n\tc0-1.1-1-2.1-2.1-2.2c-1.4-0.2-3.2-0.4-3.9-0.3c-1.2,0.1,0.9-3.6-3.6-9c-0.5-0.6-1-1.2-1.6-1.9l-2.3-3c-0.9-1.1-0.1-2.8,1.3-2.9\n\tl2-0.2h0.8c2,0.8,4.2,1.5,6.4,1.9c7.8,1.3,16.6-0.4,22.8-3.6c6.2-3.2,8.4-7.2,8.4-7.2s2.1-0.4,2.7-1.9c0.7-1.7-0.4-2.3-0.4-2.3\n\ts-2.6,1.5-7.1,2.7c-2.7,0.7-5.2,1.5-10.4,2c-4,0.6-11.8,0.5-21.2-4.9c-5.2-3-6.1-5.3-6.1-5.3s0.2,1.6,0.3,2.7\n\tc0.1,0.3-0.2,0.8-0.5,0.9l-1.5-2.4c-0.2-1-0.2-2.2-0.1-3.5c0.2-2.8,0.7-4,1.3-4c0.8,0,0.7,0.8,0.8,3.3c0.2,2.3,2.3,5.4,8,7.8\n\tc7.1,3,12.5,3.9,20.8,2.7c7.2-1,13.9-3.4,15.8-4.7c1.9-1.3,2.9-2.8,3-3.8C144.8,48.2,144.7,47.1,144,46.4z",
        },
      }),
      _vm._v(" "),
      _c(
        "g",
        [
          _c(
            "g",
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_2_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-167.1143",
                    y1: "-837.2873",
                    x2: "-146.4314",
                    y2: "-837.2873",
                    gradientTransform:
                      "matrix(0.9727 0.2322 -0.2322 0.9727 73.748 887.001)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#44338F" },
                    attrs: { offset: "0" },
                  }),
                  _vm._v(" "),
                  _c("stop", {
                    staticStyle: { "stop-color": "#1F1F4F" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("ellipse", {
                staticStyle: {
                  fill: "#FFDB2C",
                  stroke: "url(#SVGID_2_)",
                  "stroke-width": "0.6254",
                  "stroke-miterlimit": "10",
                },
                attrs: {
                  transform:
                    "matrix(0.8456 -0.5338 0.5338 0.8456 -1.4687 67.3087)",
                  cx: "115.6",
                  cy: "36.2",
                  rx: "10",
                  ry: "10",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_3_",
                gradientUnits: "userSpaceOnUse",
                x1: "-162.2484",
                y1: "-836.5439",
                x2: "-157.3079",
                y2: "-836.5439",
                gradientTransform:
                  "matrix(0.9727 0.2322 -0.2322 0.9727 73.748 887.001)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#44338F" },
                attrs: { offset: "0" },
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#1F1F4F" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("circle", {
            staticClass: "st24",
            attrs: { cx: "112.5", cy: "36.2", r: "2.5" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }